import React from "react";
import { Container, Row, Col, Button, Image, Nav } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowUpRightFromSquare,
  faEnvelope,
  faGlobe,
} from "@fortawesome/free-solid-svg-icons";

export default function Footer() {
  const supportLinks = [
    {
      label: "Feedback",
      href: "https://www.nobilitycare.com.au/feedback",
    },
    {
      label: "Privacy Policy",
      href: "https://www.nobilitycare.com.au/privacy-policy",
    },
    {
      label: "Terms & Conditions",
      href: "https://www.nobilitycare.com.au/terms-conditions",
    },
  ];

  const contactLinks = [
    {
      icon: faEnvelope,
      label: "ITsupport@nobilitycare.com.au",
      href: "mailto:itsupport@nobilitycare.com.au",
    },
    {
      icon: faGlobe,
      label: "www.nobilitycare.com.au",
      href: "https://www.nobilitycare.com.au",
    },
  ];

  return (
    <footer className="site-footer">
      <Container fluid="lg" className="py-5">
        <Row className="gy-4">
          <Col lg={4}>
            <div className="footer-brand">
              <Image
                width="120"
                fluid
                alt="Nobility Care Australia"
                src="https://www.nobilitycare.com.au/images/logo/nca-logo-icon-neg-clean.svg"
                className="mb-3"
              />
              <p className="footer-text">
                Supporting participants and teams with resources that are up to
                date, easy to access, and ready for every shift.
              </p>
              <p className="footer-text small">
                In the spirit of reconciliation, Nobility Care Australia
                acknowledges the Traditional Custodians of country throughout
                Australia and their connections to land, sea and community.
              </p>
            </div>
          </Col>
          <Col md={6} lg={4}>
            <h6 className="footer-heading">Support links</h6>
            <div className="d-grid gap-2 footer-buttons">
              {supportLinks.map((link) => (
                <Button
                  key={link.label}
                  variant="outline-light"
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="justify-content-between d-flex align-items-center"
                >
                  <span>{link.label}</span>
                  <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                </Button>
              ))}
            </div>
          </Col>
          <Col md={6} lg={4}>
            <h6 className="footer-heading">Get in touch</h6>
            <Nav className="flex-column footer-contact">
              {contactLinks.map((link) => (
                <Nav.Link
                  key={link.label}
                  href={link.href}
                  className="d-flex align-items-center"
                  target={link.href.startsWith("http") ? "_blank" : undefined}
                  rel={
                    link.href.startsWith("http")
                      ? "noopener noreferrer"
                      : undefined
                  }
                >
                  <span className="footer-contact-icon">
                    <FontAwesomeIcon icon={link.icon} />
                  </span>
                  <span>{link.label}</span>
                </Nav.Link>
              ))}
            </Nav>
          </Col>
        </Row>
        <hr className="footer-divider" />
        <Row className="gy-2 align-items-center footer-bottom">
          <Col md={6} className="text-md-start text-center">
            <small>Registered NDIS Provider</small>
          </Col>
          <Col md={6} className="text-md-end text-center">
            <small>
              © {new Date().getFullYear()} Nobility Care Australia Pty Ltd · ABN
              71 642 289 601 · ACN 642 289 601
            </small>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}
